import { render } from "./PolicyDataImport.vue?vue&type=template&id=2354435d"
import script from "./PolicyDataImport.vue?vue&type=script&lang=js"
export * from "./PolicyDataImport.vue?vue&type=script&lang=js"

import "./PolicyDataImport.vue?vue&type=style&index=0&id=2354435d&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__